export type PersonalityId = "T01" | "T02" | "T03" | "T04" | "T05" | "T06" | "T07" | "T08" | "T09" | "T10" | "T11" | "T12" | "T13" | "T14" | "T15" | "T16";

export interface PersonalityCopy {
  id: PersonalityId;
  name: string;
  tagline: string;
  body: string;
}

export const PERSONALITY_COPY_LOCK: Record<PersonalityId, PersonalityCopy> = {
  T01: {
    id: "T01",
    name: "带着回声的远行者",
    tagline: "你会往前走，过去也常常跟着一起走。",
    body: "认真喜欢过的人、花过很多时间的事、已经结束的一段生活，都会在你身上多停一会儿。它们很少拦住新的选择，却会让每次出发都多一点牵挂。你能听懂《时光机》里的回望，也会被《任意门》那种继续往前的感觉打动。记得过去，对你来说和继续生活并不冲突。你很会带着记忆走远，这让新的路始终和来处连着。",
  },
  T02: {
    id: "T02",
    name: "逆风的守梦者",
    tagline: "越难的时候，越看得出你舍不得放下什么。",
    body: "顺利时坚持并不稀奇，真正考验人的是结果迟迟不来、旁人开始劝你算了的时候。你会重新确认自己还要不要继续，只要答案仍然是“要”，就很难轻易退场。《生命有一种绝对》《顽固》里那种被现实反复碰撞后仍然保留的相信，很接近你。你愿意为认定的事多走一段，也愿意承担这段路带来的慢和累。",
  },
  T03: {
    id: "T03",
    name: "自由的开路者",
    tagline: "没有现成的路，你也愿意先走出去看看。",
    body: "现成答案很少能让你完全安心。看见新的可能，你更愿意亲自试一次，再决定它是不是自己的方向。结果当然重要，可从来没有真正替自己做过选择，会让你更不甘心。《有些事现在不做 一辈子都不会做了》《第二人生》里的出发感，和你很接近。你允许自己试错，也允许路线变化。很多答案，你宁愿走过以后再确认。",
  },
  T04: {
    id: "T04",
    name: "沉默的倔强者",
    tagline: "你最坚持的那些东西，往往没有多少观众。",
    body: "平时未必爱争，别人说什么你也会认真听。真正到了要决定的时候，你还是会回到自己的判断里。认定的东西很难因为外面的声音就轻易改变。比起万人合唱时的《倔强》，你更接近《我心中尚未崩坏的地方》那种安静的坚持。很多事不需要喊出来，也可以留很久。你很清楚自己为什么继续，这让你的倔强显得稳。",
  },
  T05: {
    id: "T05",
    name: "温柔的远行者",
    tagline: "你想去更远的地方，也一直记得谁曾经在身边。",
    body: "新的地方、新的生活会吸引你，真正进入生命的人也有很重的分量。去哪里、什么时候走、该怎样告别，你常常会多想一点。《温柔》和《任意门》放在一起，很像你的节奏：懂得顾念别人，也愿意把人生继续往外打开。你不会因为眷恋就停在原地，也很少为了出发把过去全部丢下。你的远方一直带着人情味。",
  },
  T06: {
    id: "T06",
    name: "长情的守候者",
    tagline: "有些东西在你这里，时间越久越有分量。",
    body: "热烈过去以后，一段关系真正是什么样子，你反而看得更清楚。认识很多年的人、已经融进生活的陪伴、某些不用再解释的默契，都会慢慢变重。《让我照顾你》《最重要的小事》《洗衣机》写的正是这种日常里的长期。你很少把长久当成理所当然，所以会认真记住那些一直在的人。稳定和陪伴，在你这里从来都不是无聊的词。",
  },
  T07: {
    id: "T07",
    name: "自在的探索者",
    tagline: "你对世界一直有好奇，也给自己留下转弯的余地。",
    body: "新的地方可以去，新生活可以试，走过以后发现不合适，也允许自己换个方向。你不太喜欢把一次选择变成永久承诺，更愿意保持一点空间。《轻功》《后青春期的诗》里那种轻一点的远方感，很接近你的节奏。你会去看看，再决定下一步。好奇心让你不断打开新的门，松弛感又让这些尝试没有那么沉重。",
  },
  T08: {
    id: "T08",
    name: "安静的理想家",
    tagline: "你心里一直有想过的生活，只是不太需要说给所有人听。",
    body: "你很少突然推翻一切，也不热衷把理想说得很响亮。真正重要的改变，常常藏在一些小选择里：时间给谁，什么拒绝，什么无论如何想留下。《一颗苹果》《纯真》里那种很私人的相信，和你很接近。理想在你这里不靠声量维持，而是慢慢渗进每天的决定里。最后过成什么样，比说过什么更重要。",
  },
  T09: {
    id: "T09",
    name: "清醒的远行者",
    tagline: "你会舍不得，也会承认有些路已经走完。",
    body: "越认真过的关系和生活，你越能察觉它什么时候开始变化。曾经很好值得记得，眼前已经不同也会被你看见。《志明与春娇》《终于结束的起点》里那种成年后的告别，很接近你。你愿意保留过去的分量，也愿意给现在腾出位置。离开对你来说从来不轻松，可一旦确认方向变了，你会让自己继续往前。",
  },
  T10: {
    id: "T10",
    name: "有棱角的守护者",
    tagline: "大部分事情都能商量，真正重要的地方你会站稳。",
    body: "意见不同没关系，小事退一步也没什么。碰到真正珍惜的人、关系和原则，那条线会突然变得很清楚。《武装》里那种面对世界时保住自己的姿态，很接近你。你的棱角有明确对象，很少到处伤人。越重要的东西，你越愿意认真守住。温和和坚定在你身上可以同时存在，这种分寸让人安心。",
  },
  T11: {
    id: "T11",
    name: "清醒的破局者",
    tagline: "一个问题被你看清以后，很难再靠等待拖过去。",
    body: "同样的矛盾反复出现，一个环境长期没有改变，一条路越走越窄，你会开始找新的办法。改变有代价，你知道；一直耗着同样有代价。从《疯狂世界》《嘿!我要走了》开始，五月天就不断写过离开旧局面的冲动。你更愿意把选择重新拿回手里，哪怕下一步还没有完全确定。能动起来，对你常常比继续忍耐更重要。",
  },
  T12: {
    id: "T12",
    name: "冷静的硬骨者",
    tagline: "现实很硬，你还是习惯先把能做的事做好。",
    body: "麻烦来了，情绪当然会有，只是很快就会开始看：现在还能做什么，哪一步最有用。漂亮的安慰可以听，问题开始有着落才真正让你安心。《生存以上 生活以下》《人生有限公司》《爆肝》写过很多这样的成年人时刻。你知道生活不总给理想条件，也愿意在有限的地方把事情继续推进。这种可靠很少喧哗，却很实在。",
  },
  T13: {
    id: "T13",
    name: "怀旧的漫游者",
    tagline: "过去在你这里不会轻易消失，也不急着重新回来。",
    body: "有些人离开以后仍然重要，有些地方回不去了也值得记得。你允许一些故事停在原来的地方，不急着把所有遗憾都解决掉。《如烟》《后来的我们》里那种时间感，很接近你。旧日会在某个安静时刻重新出现，连当时的年纪和生活一起回来。你很会保存真正发生过的东西，也给现在留着继续生活的位置。",
  },
  T14: {
    id: "T14",
    name: "温厚的生活家",
    tagline: "你判断一段人生好不好，最后常常会回到具体的日子。",
    body: "谁还在身边，日子舒不舒服，一段关系能不能久处，这些很容易进入你的判断。目标当然重要，可一路上留下什么同样有分量。《知足》《最重要的小事》《洗衣机》都是五月天很动人的另一面。你会认真对待普通日子里的照顾、陪伴和安稳。很多人一直在找更远的答案，你往往更早看见身边已经存在的东西。",
  },
  T15: {
    id: "T15",
    name: "洒脱的漫游者",
    tagline: "你给人生留着重新选择的余地，也允许自己改变。",
    body: "一个地方认真待过以后可以离开，一件事做过以后可以换方向。过去的选择值得尊重，却不会永远规定未来。《候鸟》《星空》《后青春期的诗》里都有这种开放感。你不急着把每一步都解释成“正确路线”，更愿意承认阶段会变，人也会变。能在变化里继续认识自己，让你不容易被旧版本困住。",
  },
  T16: {
    id: "T16",
    name: "从容的生活家",
    tagline: "你不急着一直赶路，更在意这一站过得怎么样。",
    body: "目标可以有，远方也可以想，只是它们很难自动比眼前真实的生活更重要。今天过得怎么样，身边的人合不合适，时间有没有花在值得的地方，这些更能说服你。从《生活》到《笑忘歌》，五月天一直写着平凡日子的另一种价值。你知道什么时候继续赶路，也知道什么时候安心停下来。把这一站过好，对你同样重要。",
  },
};

